module.exports = __webpack_public_path__ + "05_glasses_brown.ceab844f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer4/05_glasses_brown.png
// module id = kDJC
// module chunks = 0